import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import styled from "styled-components";
import { supabase } from "../../supabaseClient";

export default function ClientSlider() {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchImages = async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from("reviews")
        .select("image")
        .order("id", { ascending: false });
      if (!error && data) {
        setImages(data.map((r) => r.image));
        console.log(
          "Fetched images:",
          data.map((r) => r.image)
        );
      } else {
        console.log("Supabase error:", error);
      }
      setLoading(false);
    };
    fetchImages();
  }, []);

  const settings = {
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplaySpeed: 5000,
    responsive: [
      { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };

  return (
    <div className="w-[90%]  m-auto" id="coursereview">
      <h3
        style={{ fontFamily: "Josefin Sans, sans-serif" }}
        className="text-center pb-4  font30 extraBold"
      >
        Course Reviews
      </h3>
      {loading ? (
        <div style={{ textAlign: "center", padding: 40 }}>Loading...</div>
      ) : (
        <Slider {...settings} autoplay>
          {images.map((img, idx) => (
            <img key={idx} className="h-100 p-8" src={img} alt="review" />
          ))}
        </Slider>
      )}
    </div>
  );
}

const LogoWrapper = styled.div`
  width: 90%;
  padding: 0 5%;
  cursor: pointer;
  :focus-visible {
    outline: none;
    border: 0px;
  }
`;
